export default {
  screens: [
    {
      type: 'intro',
      title: '王者之选',
      content:
        'CHAUMET作为拿破仑御用的珠宝工匠，赋予其珠宝作品浓烈的权力象征，也由此开创出多个掀起珠宝艺术风潮的主题系列。',
      idYt: 'q7zuNJ10apM',
      videoCover: 'world/sovereign/video.jpg',
      desktop: {
        cover: 'world/sovereign/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sovereign/mobile-cover-1.jpg',
        contentStyle: { width: '70%' },
        coverStyle: {
          width: '110%',
          top: '90%',
          left: '15%',
          position: 'absolute'
        }
      },
      isBottom: true
    },
    {
      type: 'columnVideo',
      content:
        '毋容置疑，在所有拿破仑皇帝赠与的外交礼物中，教皇庇护七世的冠冕当属重中之重。1804年12月2日，拿破仑赠予教皇庇护七世这顶冠冕，以示对罗马教皇莅临加冕典礼的感谢。',
      idYt: 'O-1TKgKxDdg',
      videoCover: 'world/sovereign/video-2.jpg',
      cover: 'world/sovereign/cover-2.jpg',
      isBottom: true
    },
    {
      type: 'video',
      middleImg: 'world/sovereign/tiare.jpg',
      videoBlock: {
        cover: 'world/sovereign/video-3.jpg',
        idYt: '5ExHUFrxFms'
      },
      content:
        '在此展览之际，梵蒂冈教皇委托CHAUMET重新修缮这顶冠冕，并令其创作出一款以便镶嵌别致加冕绿宝石（名为“ Jules II ”）的十字架。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/sovereign.js